import React, { useState } from "react";
import FadeInSection from "../../../Components/FadeInSection";

const DashboardFeaturesEdit = ({ data, onClose, onSave }) => {
  const [title, setTitle] = useState(data.title || "");
  const [description, setDescription] = useState(data.description || "");
  const [image, setImage] = useState(data.image || null);
  const [Tutorial, setTutorial] = useState(data.Tutorial || "");

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files?.length > 0) {
      setImage(files[0]); // Store the file directly, not as a nested object
    } else {
      // setImage((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    try {
      const formData = new FormData();

      // First, add all existing data properties
      Object.keys(data).forEach((key) => {
        // Skip image since we'll handle it separately
        if (key !== "image") {
          formData.append(key, data[key]);
        }
      });
      formData.append("title", title);
      formData.append("description", description);
      if (image && image !== data.image) {
        formData.append("image", image);
      }
      formData.append("Tutorial", Tutorial);
      console.log("Attempting edit for: ", formData);
      await onSave(formData);
    } catch (error) {
      console.error("Failed to save feature", error);
    }
  };

  return (
<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
      <div className="w-[0vw] md:w-1/6"></div>
      <div
          className={`bg-white p-6 rounded shadow-lg w-full h-full flex flex-col overflow-auto`}
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Edit Feature
          </h2>
          <div className="border-t border-gray-200 mb-6"></div>
          <div className="flex flex-col space-y-8 flex-grow">
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Title</p>
              <textarea
                className="w-2/3 border rounded p-2 text-gray-800"
                rows="2"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Description
              </p>
              <textarea
                className="w-2/3 border rounded p-2 text-gray-800"
                rows="4"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Image</p>
              <input
                type="file"
                className="w-2/3 border rounded p-2 text-gray-800"
                name="image"
                accept="image/jpeg, image/png, image/jpg, image/gif"
                onChange={handleInputChange}
              />
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Tutorial
              </p>
              <input
                type="text"
                className="w-2/3 border rounded p-2 text-gray-800"
                value={Tutorial}
                name="Tutorial"
                onChange={(e) => setTutorial(e.target.value)}
              />
            </div>
          </div>
          <div className="mt-6 flex justify-start space-x-4">
            <button
              className="px-4 py-2 bg-gray-100 text-gray-600 rounded-lg"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      {/* </FadeInSection> */}
    </div>
  );
};

export default DashboardFeaturesEdit;
